import Env from '../base/env';
import Component from 'gia/Component';
import gsap from 'gsap';
import { ScrollTrigger } from '../vendor/gsap-bonus-umd/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
import easesCustom from '../fx/CustomEases';

export default class Module extends Component
{
  mount() {
    this.DOM = {}
    this.DOM.view = this.element
    this.DOM.picture = this.DOM.view.querySelector('.fxPicture')
    this.DOM.visual = this.DOM.view.querySelector('.fxVisual')
    this.DOM.texts = this.DOM.view.querySelectorAll('.fxText')
    this.DOM.separator = this.DOM.view.querySelector('.fxSeparator')
    this.DOM.separatorV = this.DOM.view.querySelector('.fxSeparatorV')
    // Vars
    this.CAN_HOVERED = false
    //? Fns
    gsap.delayedCall(.1,()=>{
      this._fx()
    });
  }

  _fx()
  {
    this.animate()
    this.reveal()
    this.hover()
  }

  animate()
  {
    let setDelay = this.DOM.view.getAttribute('data-delay') * 1
    let setImmediateRendering = false
    if(Env.mobileCSS) {
      setDelay = 0
    }
    if(setDelay > 0) {
      setImmediateRendering = true
    }
    this.animation = gsap.timeline({ delay:setDelay })

    let fxTexts = {
      from: {
        autoAlpha:0,
        y:150
      },
      to:{
        autoAlpha:1,
        y:0,
        ease:easesCustom.quart,
        duration:.7,
        delay:.3,
        stagger:.2
      }
    }
    if(Env.mobileCSS) {
      fxTexts.from = {
        autoAlpha:0,
        y:0
      }
      fxTexts.to = {
        autoAlpha:1,
        ease:easesCustom.cubic,
        duration:.7,
        delay:.3,
      }
    }

    this.animation
    .add([
      gsap.fromTo(
        this.DOM.picture,
        {
          autoAlpha:0
        },
        {
          autoAlpha:1,
          ease:easesCustom.quart,
          duration:1.2,
          delay:.2
        }
      ),
      gsap.fromTo(
        this.DOM.visual,
        {
          scale:1.2
        },
        {
          immediateRender:setImmediateRendering,
          scale:1.01,
          ease:easesCustom.quart,
          duration:1.4,
          onStart:()=>{
            setTimeout(() => {
              gsap.set(this.DOM.visual,{ autoAlpha:1 })
              this.DOM.picture.classList.remove('util-hidden-fx')
            }, 200);
          }
        }
      ),
      gsap.fromTo(
        this.DOM.texts,
        fxTexts.from,
        fxTexts.to
      ),
    ])
    .add(()=>{
      this.CAN_HOVERED = true
    })
    if(this.DOM.separator != null)
    {
      this.animation.add([
        gsap.fromTo(
          this.DOM.separator,
          {
            scaleX:0,
            transformOrigin:'left top'
          },
          {
            scaleX:1,
            ease:easesCustom.quart,
            duration:.7
          }
        )
      ],'<-.5')
    }
    if(this.DOM.separatorV != null)
    {
      this.animation.add([
        gsap.fromTo(
          this.DOM.separatorV,
          {
            scaleY:0,
            transformOrigin:'left top'
          },
          {
            scaleY:1,
            ease:easesCustom.cubic,
            duration:1
          }
        )
      ],'<-.8')
    }
  }

  hover()
  {
    const ease = 'cubic.out';
    this.DOM.view.addEventListener('mouseenter',()=>{
      if(this.CAN_HOVERED) {
        gsap.to(
          this.DOM.visual,
          {
            scale:1.08,
            ease:ease,
            duration:.7,
          }
        )
      }

    })
    this.DOM.view.addEventListener('mouseleave',()=>{
      if(this.CAN_HOVERED) {
        gsap.killTweensOf(this.DOM.view)
        gsap.to(
          this.DOM.visual,
          {
            scale:1.01,
            ease:ease,
            duration:.7,
          }
        )
      }
    })
  }

  reveal()
  {
    let offsetStart = (Env.mobileCSS)?'top 85%':'top 70%';
    if(typeof this.DOM.view.getAttribute('data-offset-start') != 'undefined') {
      offsetStart = this.DOM.view.getAttribute('data-offset-start')
    }
    this.st = ScrollTrigger.create({
      animation:this.animation,
      trigger:this.DOM.view,
      start:offsetStart,
    })
  }

  unmount()
  {
    this.st.kill()
  }
}
